import { _notifyVisibilityChanged } from '@statsig/react-bindings'
import { AppState } from 'react-native'

// Vendored from @statsig/react-native-core's AppVisiblityShim. statsig's event
// logger flushes on visibility changes; on web that's driven by
// `document`/`window` events, which don't exist in RN. Bridge RN's `AppState`
// to statsig's `_notifyVisibilityChanged` so flush-on-background works.

let isApplied = false

export function applyAppStateVisibilityShim(): void {
  if (isApplied) {
    return
  }

  isApplied = true
  AppState.addEventListener('change', (nextAppState) =>
    _notifyVisibilityChanged(
      nextAppState === 'active' ? 'foreground' : 'background',
    ),
  )
}
